module.exports = __webpack_public_path__ + "img/img_manual1_2.a34e514a.jpg";